export default "__VITE_ASSET__BwueFKND__"